<template>
  <div>
    <img
      :src="message.content.url"
      alt="gif"
      :class="$style.img"
    >
  </div>
</template>

<script>
export default {
  name: 'message-content-giphy',
  props: {
    message: {
      type: Object,
      required: true
    }
  }
}
</script>

<style module lang="scss">
.img {
  max-width: 85%;
  max-height: 300px;
  object-fit: contain;
  object-position: left top;
  height: 100%;
}
</style>
